import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getEcotrapPage } from "@/_pages/ecotrap/api";
import type { EcotrapType } from "@/_pages/ecotrap/model";
import { EcotrapPage } from "@/_pages/ecotrap/ui";

type Params = {
  slug: string;
};

type PageProps = {
  cms: {
    ecotrap: EcotrapType;
  };
};

const Page = ({ cms }: PageProps) => {
  return <EcotrapPage {...cms} />;
};

export const getServerSideProps: GetServerSideProps<{}, Params> = async (
  context,
) => {
  const { res } = context;
  const { slug } = context.params!;

  return await loadPageWithGlobal(
    async () => {
      const cms = await getEcotrapPage(slug);

      return {
        ...cms,
      };
    },
    { res },
  );
};

export default Page;
